import { render, staticRenderFns } from "./xxcj.vue?vue&type=template&id=a20621c8&scoped=true&"
import script from "./xxcj.vue?vue&type=script&lang=js&"
export * from "./xxcj.vue?vue&type=script&lang=js&"
import style0 from "./xxcj.vue?vue&type=style&index=0&id=a20621c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20621c8",
  null
  
)

export default component.exports